import React from "react";
import moment from "moment";
import { Box } from "@mui/material";
import { convertADtoBS } from "../../../../components/Calendar/functions/calendarFunctions";
import Headers, { Reports } from "../Headers";
import ProfitLossList from "./ProfitLossList";
import useProfitLoss from "./hooks/useProfitLoss";
import Filters from "../Filters";

const ProfitLoss = (): React.ReactElement => {
  const [filters, setFilters] = React.useState({
    periodDate: new Date(),
    showPreviousYearPeriod: false
  });
  const data = useProfitLoss(filters);
  const headers = filters.showPreviousYearPeriod
    ? [
        { key: "description", label: "Description", className: "flex-1" },
        { key: "ledgerName", label: `${convertADtoBS(moment(filters.periodDate)).formatted4}` },
        {
          key: "ledgerType",
          label: `${convertADtoBS(moment(filters.periodDate).subtract(1, "year")).formatted4}`
        }
      ]
    : [
        { key: "description", label: "Description", className: "flex-1" },
        { key: "ledgerName", label: `${convertADtoBS(moment(filters.periodDate)).formatted4}` }
      ];

  return (
    <Box className="bSheetPLossReport">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ p: 3 }}>
          <Filters filters={filters} setFilters={setFilters} />
        </Box>

        <Box
          sx={{
            borderTop: 1,
            borderBottom: 1,
            borderColor: "divider"
          }}
        >
          <Headers data={data} filters={filters} report={Reports.PROFIT_LOSS} headers={headers} />
        </Box>

        <Box
          sx={{
            height: "calc(100vh - 250px)",
            overflow: "auto",
            scrollbarGutter: "stable",
            width: "100%",
            overflowX: "auto"
          }}
        >
          <ProfitLossList data={data} showPreviousYearPeriod={filters.showPreviousYearPeriod} />
        </Box>
      </Box>
    </Box>
  );
};

export default ProfitLoss;
